// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"16a21490","355":"e86be305"}[chunkId] + ".chunk.js";
};